import React, { useEffect, useState } from 'react';
import { FiCheckCircle, FiXCircle, FiAlertCircle } from 'react-icons/fi';
import './CommandNotification.css';

const CommandNotification = ({ 
  show, 
  success, 
  message, 
  errorCode = null,
  onClose,
  duration = 3000 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    if (show) {
      // Small delay to trigger animation
      setTimeout(() => setIsVisible(true), 10);
      
      // Auto-hide after duration
      const hideTimer = setTimeout(() => {
        setIsLeaving(true);
        setTimeout(() => {
          setIsVisible(false);
          setIsLeaving(false);
          onClose?.();
        }, 300);
      }, duration);

      return () => clearTimeout(hideTimer);
    } else {
      setIsVisible(false);
      setIsLeaving(false);
    }
  }, [show, duration, onClose]);

  if (!show && !isVisible) return null;

  const getIcon = () => {
    if (success) {
      return <FiCheckCircle className="notification-icon success" />;
    } else if (errorCode !== null) {
      return <FiXCircle className="notification-icon error" />;
    } else {
      return <FiAlertCircle className="notification-icon warning" />;
    }
  };

  const getStatusClass = () => {
    if (success) return 'success';
    if (errorCode !== null) return 'error';
    return 'warning';
  };

  return (
    <div className={`command-notification-container ${isVisible ? 'visible' : ''} ${isLeaving ? 'leaving' : ''}`}>
      <div className={`command-notification ${getStatusClass()}`}>
        <div className="notification-content">
          {getIcon()}
          <div className="notification-text">
            <p className="notification-message">{message}</p>
            {errorCode !== null && errorCode < 0 && (
              <p className="notification-error-code">Error Code: {errorCode}</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommandNotification;
